import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import CampaignListComponent from '../../../Components/CampaginComponent/CampaignListComponent';
function CampaignList(props) {
    let navigate = useNavigate();
    const params = useParams();
    return (
        <div>
            <CampaignListComponent {...props} navigate={navigate} id={params.id}  />
        </div>
    );

}

export default CampaignList